var map = {
	"./img1.png": "09dd",
	"./img2.png": "4fab",
	"./img3.png": "e61a",
	"./img4.png": "4460",
	"./img5.png": "a3ae",
	"./img6.png": "2541",
	"./img7.png": "8dbf",
	"./img8.png": "5753"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1cca";